import CalenderIcon from "../../../assets/svg/calander-icon-1.svg";
import userImage from "../../../assets/user.png";

function CommitteePostDetails({ post, setCurrentView }) {
  const ImageURL = process.env.REACT_APP_API_IMAGE_URL + "/";
  const plainText = post?.description?.replace(/<[^>]+>/g, "") || "";
  return (
    <>
      {/* <section>
        <div className="container"> */}
      <div style={{ marginBottom: "40px" }}>
        <h1 className="UserPostHeading">{post?.title}</h1>
        <p className="UserPostSubHeading">
          <img src={CalenderIcon} alt="" height={"18px"} aria-hidden="true" />
          &nbsp;
          {new Date(post?.createdAt).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })}
          ,{" "}
          {new Date(post?.createdAt).toLocaleTimeString("en-US", {
            hour: "numeric",
            minute: "2-digit",
            hour12: true,
          })}
          &nbsp;&nbsp;
          <img src={userImage} alt="" height={"16px"} aria-hidden="true" />{" "}
          {post?.createdBy?.firstName} {post?.createdBy?.lastName}
        </p>
        <div
          className="UserPostContent"
          dangerouslySetInnerHTML={{
            __html: plainText,
          }}
          style={{ wordBreak: "break-word" }}
        ></div>
        <div className="d-flex flex-column gap-2">
          {post?.files?.length > 0 &&
            post?.files?.map((file) => {
              return (
                <a
                  target="_blank"
                  href={`${ImageURL}${file?.file}`}
                  rel="noopener noreferrer"
                  aria-label={`Download document for ${post?.title || "post"}`}
                >
                  <i className="fa fa-download" aria-hidden="true"></i> Download
                  document here
                </a>
              );
            })}
        </div>
        <div className="mt-3">
          <button
            type="submit"
            className="sign-in-button"
            onClick={() => {
              setCurrentView("list");
              // setViewPost(post);
            }}
          >
            Go Back to All Posts
            {/* View Post */}
            <i className="mx-2 css-arrow-icon bi bi-arrow-left"></i>
          </button>
        </div>
        <hr />
      </div>
      {/* </div>
      </section> */}
    </>
  );
}

export default CommitteePostDetails;
